import React from "react";
import { Box } from "@chakra-ui/react";
import { TableVirtuoso } from "react-virtuoso";
function safeText(v) {
    if (v === null || v === undefined)
        return "";
    return String(v);
}
export class VirtualizedReportTable extends React.PureComponent {
    constructor() {
        // Chakra-compatible table components for Virtuoso
        super(...arguments);
        this.fixedHeaderContent = () => {
            const { report } = this.props;
            return (React.createElement("tr", null, report.columns.map((c) => (React.createElement("th", { key: c.id, style: {
                    textAlign: c.isNumeric ? "right" : "left",
                    padding: "10px 12px",
                    fontSize: 12,
                    color: "#4A5568",
                    borderBottom: "1px solid #E2E8F0",
                    width: 250,
                    maxWidth: 250,
                    background: "#F7FAFC",
                    zIndex: 2,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis"
                } }, c.header)))));
        };
        this.itemContent = (_index, row) => {
            const { report, onRowClick } = this.props;
            return report.columns.map((c) => {
                const anyRow = row;
                const val = c.accessorKey ? anyRow[c.accessorKey] : undefined;
                return (React.createElement("td", { key: c.id, onClick: () => onRowClick && onRowClick(row), style: {
                        padding: "10px 12px",
                        borderBottom: "1px solid #EDF2F7",
                        textAlign: c.isNumeric ? "right" : "left",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        cursor: onRowClick ? "pointer" : "default",
                        width: 250,
                        maxWidth: 250
                    } }, c.cell ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: c.cell(row) } })) : (safeText(val))));
            });
        };
    }
    render() {
        const { rows, height } = this.props;
        console.log(rows);
        return (React.createElement(Box, { borderWidth: "1px", borderRadius: "md", overflow: "hidden", height: height !== null && height !== void 0 ? height : 520 },
            React.createElement(TableVirtuoso, { data: rows, style: { height: height !== null && height !== void 0 ? height : 520, width: "100%" }, fixedHeaderContent: this.fixedHeaderContent, itemContent: this.itemContent, overscan: 50 })));
    }
}
